import React from 'react';
import { ITableProps } from '../../types.type';
import { useTranslation } from 'react-i18next';

export const ManagememtContainer = ({ children, onClick }: ITableProps) => {
  const { t } = useTranslation();
  return (
    <div className="md:mt-[32px] px-[22px] md:px-[72px] max-w-[945px] lg:max-w-5xl mx-auto">
      <div className="flex relative flex-col m-w-fit">
        <h1 className="text-[26px] font-display font-bold text-content-dark tracking-tight">
          {t('management.title')}
        </h1>
        <p className="font-body text-[13.5px] text-content-muted-alt mt-[4px] mb-[36px]">
          {t('management.subtitle')}
        </p>
        {children}
      </div>
    </div>
  );
};
